import { useEffect } from "react";
import { useCompany } from "../context/CompanyContext";
import { db } from "../firebase";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { useAuthz } from "../context/AuthzContext";

export default function CompanyInitializer() {
  const { companies, setCompanyList, refreshTick } = useCompany();
  const { isLoading, isAuthenticated, isSuperAdmin, tenantId } = useAuthz();

  useEffect(() => {
    if (isLoading) return;

    if (!isAuthenticated) {
      setCompanyList([]);
      return;
    }

    async function fetchCompanies() {
      try {
        let companyList = [];

        if (isSuperAdmin) {
          const querySnapshot = await getDocs(collection(db, "companies"));
          companyList = querySnapshot.docs.map((item) => ({ id: item.id, ...item.data() }));
        } else if (tenantId) {
          const tenantDocRef = doc(db, "companies", tenantId);
          const tenantDoc = await getDoc(tenantDocRef);
          companyList = tenantDoc.exists() ? [{ id: tenantDoc.id, ...tenantDoc.data() }] : [];
        }

        setCompanyList(companyList);
      } catch (error) {
        // Optionally handle error (e.g., show alert or log)
        setCompanyList([]);
      }
    }

    if (!companies || companies.length === 0) {
      fetchCompanies();
    }
  }, [companies, isAuthenticated, isLoading, isSuperAdmin, setCompanyList, tenantId, refreshTick]);

  return null;
}

